import React from 'react';
import { useState, useEffect } from 'react';
import '../../scss/reusables/forms-table.scss';
import getCommonResponse from '../actions/Common';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import trash from '../../images/common/trash.png';
import download from '../../images/projectdetails/download.png';
import { convertUTCToPST, getCSVData } from '../Reusables/Function';
import DeleteItem from '../popups/DeleteItem';
import FormSubmission from '../popups/FormSubmission';


function FormsTable(props) {
    const {id, page} = props;

    const navigate = useNavigate();

    const [fiveFormsList, setFiveFormsList] = useState([]);
    const [formsList, setFormsList] = useState([]);
    const [showAllForms, setShowAllForms] = useState(false);
    const [deleteForm, setDeleteForm] = useState(false);
    const [deleteFormId, setDeleteFormId] = useState(false);
    const [formSortState, setFormSort] = useState(false);
    const [formSortValues, setFormSortValues] = useState({
        sortBy: null,
        sortType: null
    })
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const handleCloseDeletePopup = () => setShowDeleteForm(false);
    const handleShowDeletePopup = () => setShowDeleteForm(true);
    const [toggle, setToggle] = useState(false);
    const [showform, setShowform] = useState(false);
    const [formListData, setFormListData] = useState('');
    const [formEditted, setFormEditted] = useState(null);
    const [downloadLink, setDownloadLink] = useState([]);
    
    var forms = showAllForms ? formsList : fiveFormsList;

    const handleFormShow = () => {
        setToggle(!toggle)
        setShowform(true);
    }
    const handleFormHide = () => setShowform(false);

    const callFormListApi = () => {
        const callApi = (accesstoken) => {
            if(accesstoken == '') {
                navigate('/');
            } else {
                if(page == "overview-entity" || page == "edit-entity" || page == "overview-edit-entity") {
                    const URL = `/api/Entity/${id}/forms${formSortValues.sortBy ? `?sort_by=${formSortValues.sortBy}` : ''}${formSortValues.sortType ? `&sort_type=${formSortValues.sortType}` : ''}`
                    getFormList(URL, accesstoken)
                }
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    useEffect(() => {
        callFormListApi();
    }, [formSortState, deleteForm, page])

    useEffect(() => {
        if(formEditted) {
            callFormListApi();
        }
    }, [formEditted])

    const getFormList = (endpoint, accesstoken) => {
        getCommonResponse.GetDetailsWithToken(endpoint, accesstoken, (data) => {
            if(data.status == 200) {
                setFormEditted(false);

                if(data.data.data.length <= 5) {
                    setFiveFormsList(data.data.data);
                    setFormsList(data.data.data);
                } else {
                    var files = [];
                    for(var i = 0; i < 5; i++) {
                        files.push(data.data.data[i])
                    }
                    setFiveFormsList(files);
                    setFormsList(data.data.data);
                }

                setDownloadLink(getCSVData(data.data.data))
            } else if(data.status == 401) {
                navigate("/login")
            }
        })
    }

    const showFile = () => {
        setShowAllForms(!showAllForms);
    }

    function sortForm(dataset) {
        setFormSortValues({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        if(dataset.sortType === 'asc') {
            setFormSort(!formSortState);
        } else {
            setFormSort(!formSortState);
        }
    }

    const handleFormData = (item, event) => {
        event.stopPropagation();
        handleFormShow();
        setFormListData(item);
    }
    
    const handleFormDownload = (e, item, index) => {
        e.stopPropagation();
        const element = document.createElement("a");
        element.href = downloadLink[index];
        element.download = `${item.title}.txt`;
        document.body.appendChild(element);
        element.click();
    }

    const handleDeleteForm = (id,event) => {
        event.stopPropagation();
        setDeleteFormId(id);
        handleShowDeletePopup();
    }

    const callDeleteFormApi = () => {
        const URL = `/api/project/form/delete/${deleteFormId}`
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getCommonResponse.DeleteApi(URL, accesstoken, (response) => {
                    if(response.status == 200) {
                        setDeleteForm(deleteFormId);
                        handleCloseDeletePopup();
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    return (
        <div id='forms' className='forms-section'>
            <div className='forms-container'>
                <div className='forms-left'>
                    <div className='forms'>Form Submission</div>
                    <div className='showing'>Showing { forms && forms.length } forms of { formsList && formsList.length }</div>
                    { formsList && formsList.length > 5 &&
                        <div className='showall' onClick={showFile}>{showAllForms ? "Show Less" : "Show All"}</div>
                    }
                </div>
            </div>
            <div className='forms-table'>
                <table>
                    <thead>
                        <tr className='heading-row'>
                            <th className='heading-data first-data' style={{minWidth: "200px"}}>Name</th>
                            <th className='heading-data' style={{minWidth: "200px"}}>
                                <div className='heading-arrows'>
                                    <div>Title</div>
                                    <div className='sort-arrows'>
                                        {
                                            !(formSortValues.sortBy === 'title' && formSortValues.sortType === 'asc') &&
                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='title' data-sort-type='asc' onClick={(e) => sortForm(e.target.dataset)}></img>
                                        }
                                        {
                                            !(formSortValues.sortBy === 'title' && formSortValues.sortType === 'desc') &&
                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='title' data-sort-type='desc' onClick={(e) => sortForm(e.target.dataset)}></img>
                                        }
                                    </div>
                                </div>
                            </th>
                            <th className='heading-data' style={{minWidth: "170px"}}>
                                <div className='heading-arrows'>
                                    <div>Date & Time</div>
                                    <div className='sort-arrows'>
                                        {
                                            !(formSortValues.sortBy === 'date' && formSortValues.sortType === 'asc') &&
                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='date' data-sort-type='asc' onClick={(e) => sortForm(e.target.dataset)}></img>
                                        }
                                        {
                                            !(formSortValues.sortBy === 'date' && formSortValues.sortType === 'desc') &&
                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='date' data-sort-type='desc' onClick={(e) => sortForm(e.target.dataset)}></img>
                                        }
                                    </div>
                                </div>
                            </th>
                            <th className='heading-data action-heading' style={{width: "100px"}}>Actions</th>
                        </tr>
                    </thead>
                    {
                    forms.length === 0 ? <p className="no-result">No results found</p> :
                        <tbody>
                            { forms && forms.length > 0 && forms.map((item, index) => {
                                return (
                                    <tr className='details-list-row' key={index} onClick={(event) => handleFormData(item, event)}>
                                        <td className='details-list-data first-data'>{`${item.contact && item.contact['firstName']}`+' '+`${(item.contact && item.contact['lastName']) ? item.contact['lastName'] : ""}`}</td>  
                                        <td className='details-list-data'>{item.title && item.title}</td>
                                        <td className='details-list-data'>{convertUTCToPST(item.createdDate + 'Z', "updates")}</td>
                                        <td className='details-list-data action'>
                                            <img className='download' src={download} alt="download" onClick={(e) => handleFormDownload(e, item, index)}/>
                                            <img id={`${index}`} className='trash' onClick={(event) => handleDeleteForm(item.idFormSubmission,event)} src={trash} alt="delete"></img>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    }   
                </table>
            </div>
            {formListData &&
                <FormSubmission showform={showform} handleFormHide={handleFormHide} formlistdata={formListData} toggle={toggle} setFormEditted={setFormEditted}/>
            }
            {/* Showing delete popup */}
            <DeleteItem show={showDeleteForm} handleClose={handleCloseDeletePopup} deleteApiCall={callDeleteFormApi} enable={true}/>
        </div>
    );
}

export default FormsTable;